export interface Company {
  slug: string;
  name: string;
  tagline: string;
  logo: string;
  website?: string;
  description: string;
  description_ja: string;
  businessOverview: { title: string; desc: string }[];
  businessOverview_ja: { title: string; desc: string }[];
  info: {
    companyName?: string;
    companyName_ja?: string;
    representative: string;
    representative_ja: string;
    established: string;
    capital?: string;
    capital_ja?: string;
    business: string;
    business_ja: string;
    mainBank?: string;
    mainBank_ja?: string;
    location: string;
    location_ja: string;
  };
  mapCode?: string;
  accentColor: string;
  bgColor: string;
}

export const groupCompanies: Company[] = [
  {
    slug: "swell-holdings",
    name: "SWELL HOLDINGS",
    tagline: "Corporate Holding Company",
    logo: "/logo/swell.png",
    website: "https://swell-hd.com/",
    description: "SWELL HOLDINGS is a diversified holding company that drives innovation across marketing, creative, and lifestyle industries\nWe believe in the power of different perspectives to shape the future",
    description_ja: "SWELL HOLDINGSは、マーケティング、クリエイティブ、ライフスタイル\n多岐にわたってイノベーションを推進する多角的な持株会社です\n私たちは、異なる視点の力が未来を形作ると信じています",
    businessOverview: [
      { title: "Management", desc: "Holding shares of group companies and overall management of the group through these holdings" },
      { title: "Strategy", desc: "Strategic planning and management guidance for group companies" },
      { title: "Finance", desc: "Group-wide financial management, fundraising, and administration" },
    ],
    businessOverview_ja: [
      { title: "経営管理", desc: "グループ会社の株式の保有およびこれらを通じたグループ全体の経営管理" },
      { title: "戦略立案", desc: "グループ会社の戦略立案および経営指導" },
      { title: "財務・資金調達", desc: "グループ共通の財務・資金調達および管理" },
    ],
    info: { 
      companyName: "SWELL HOLDINGS Co., Ltd.",
      companyName_ja: "株式会社スウェル・ホールディングス",
      representative: "SATOSHI NISHIKAWA",
      representative_ja: "西川 聡",
      established: "2021",
      capital: "6,000,000 JPY",
      capital_ja: "600万円",
      business: "Group corporate management / Incidental business",
      business_ja: "グループ会社の経営管理・付帯業務",
      mainBank: "Mizuho Bank, Nakameguro Branch",
      mainBank_ja: "みずほ銀行 中目黒支店",
      location: "1-15-11 1F, Kamimeguro, Meguro-ku, Tokyo",
      location_ja: "〒153-0051 東京都目黒区上目黒1-15-11 1F"
    },
    mapCode: `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3242.2396571747736!2d139.6980525!3d35.6464666!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188bfbac2751d9%3A0x2e161e75a54d87e3!2sSwell%20Coffee%20Roasters!5e0!3m2!1sja!2sjp!4v1774017463124!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`,
    accentColor: "#000000",
    bgColor: "#FFFFFF",
  },
  {
    slug: "swell-partners",
    name: "SWELL PARTNERS",
    tagline: "Marketing Agency",
    logo: "/logo/sp.png",
    website: "http://tainc.jp/",
    description: "Understanding the source of value and emotion for artists, athletes, and IP, we strategically design fan touchpoints and stories. We maximize content value and the potential of everyone in the entertainment business, including creators, fans, and supporting staff.",
    description_ja: "アーティスト・アスリート・IP⸺その価値と感情が動く源泉を深く理解し、ファンとの接点とストーリーを戦略的に設計。コンテンツの価値を最⼤化すると共に、クリエイター、ファン、そして現場を⽀えるスタッフも含め、エンタテインメントビジネスに関わるすべての⼈の可能性を最⼤化します。",
    businessOverview: [
      { 
        title: "Marketing Support", 
        desc: "End-to-end support from strategy design to execution and analysis to enhance brand value" 
      },
      { 
        title: "Promotion", 
        desc: "Integrated promotion services including planning, production, and distribution to drive awareness" 
      },
      { 
        title: "Management Support", 
        desc: "Comprehensive support for organizational strategy, operational improvement, and team development" 
      }
    ],
    businessOverview_ja: [
      { title: "マーケティング支援", desc: "マーケティング戦略設計から施策実行、効果検証まで一貫支援し、売上拡大とブランド価値向上を実現するサービスです" },
      { title: "プロモート", desc: "商品の魅力を的確に伝える企画・制作・発信を一貫して行い、認知拡大と購買促進を実現するプロモーション支援サービスです" },
      { title: "マネジメントサポート", desc: "組織運営の課題を可視化し、戦略設計・業務改善・チーム育成を包括的に支援し経営判断の質を高め、持続的な成長を実現するマネジメントサポートです" },
    ],
    info: { 
      companyName: "SWELL PARTNERS Co., Ltd.",
      companyName_ja: "株式会社スウェル・パートナーズ",
      representative: "Representative Director: SATOSHI NISHIKAWA\nDirector: KEISUKE ABE\nDirector: SHINGO ODAKA",
      // 全角スペースで縦のラインを調整
      representative_ja: "代表取締役　西川 聡\n取締役　　阿部 圭佑\n取締役　　小高 慎吾",
      established: "2021",
      capital: "3,000,000 JPY",
      capital_ja: "300万円",
      business: "Marketing support, promotion, and management support",
      business_ja: "マーケティング支援、プロモート、マネジメントサポート",
      mainBank: "Sumitomo Mitsui Banking Corporation, Gotanda Branch",
      mainBank_ja: "三井住友銀行 五反田支店",
      location: "1-15-11 1F, Kamimeguro, Meguro-ku, Tokyo",
      location_ja: "〒153-0051 東京都目黒区上目黒1-15-11 1F"
    },
    mapCode: `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3242.2396571747736!2d139.6980525!3d35.6464666!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188bfbac2751d9%3A0x2e161e75a54d87e3!2sSwell%20Coffee%20Roasters!5e0!3m2!1sja!2sjp!4v1774017463124!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`,
    accentColor: "#2D2D2D",
    bgColor: "#F0F2F5",
  },
  {
    slug: "swell-coffee",
    name: "SWELL COFFEE ROASTERS",
    tagline: "Specialty Coffee Roasters",
    logo: "/logo/swell.png",
    website: "http://swell-c.com/",
    description: "SWELL COFFEE ROASTERS is a specialty coffee roaster focusing on bean potential and precise extraction\nA brand where you can enjoy aromatic coffee in a comfortable atmosphere",
    description_ja: "SWELL COFFEE ROASTERSは、素材の個性を引き出す焙煎と丁寧な抽出が魅力のスペシャリティコーヒーロースター\n心地よい空間で、香り豊かな一杯を楽しめるブランドです",
    businessOverview: [
      { title: "Cafe Management", desc: "Operation of specialty coffee cafes and serving fresh house-roasted beans" },
      { title: "Online Sales", desc: "E-commerce business for freshly roasted coffee beans and equipment" },
      { title: "Wholesale Supply", desc: "B2B wholesale of specialty coffee beans for professional use" },
    ],
    businessOverview_ja: [
      { title: "カフェ運営", desc: "自家焙煎スペシャリティコーヒーの提供およびカフェ運営" },
      { title: "ネット販売", desc: "自家焙煎コーヒー豆のオンライン販売およびEC事業" },
      { title: "卸売供給", desc: "自家焙煎コーヒー豆の卸売りおよび業務用販売" },
    ],
    info: { 
      representative: "SATOSHI NISHIKAWA",
      representative_ja: "西川 聡",
      established: "2021",
      business: "Cafe management, coffee bean roasting and sales",
      business_ja: "カフェ運営、コーヒー豆の焙煎・販売",
      location: "1-15-11 1F, Kamimeguro, Meguro-ku, Tokyo",
      location_ja: "〒153-0051 東京都目黒区上目黒1-15-11 1F"
    },
    mapCode: "",
    accentColor: "#5C4033",
    bgColor: "#FAF7F2",
  },
 {
    slug: "rice-ball",
    name: "RICEBALL PLANNING",
    tagline: "Athlete Agencies",
    logo: "/logo/rb.png",
    website: "https://riceballpress.com/",
    description: "We perform services to create an environment where athletes can reach peak performance while valuing communication and trust with each individual\nWe execute strategic casting, marketing, and merchandising to maximize athletes' social value and drive market growth",
    description_ja: "アスリートがそれぞれのフィールドで、最高のパフォーマンスを発揮できる環境作りをサポートします\nひとりひとりのアスリートとのコミュニケーションを大切にし、“信頼”を積み重ねていく事で、個々に寄り添ったサービスを提供します",
    businessOverview: [
      { title: "Casting", desc: "We perform optimal casting support by believing that shared vision between athletes and clients is the root of deep emotion and leveraging athlete expertise" },
      { title: "Marketing", desc: "We perform marketing operations to pursue athletes' social value and create new business through co-creation with corporations and diverse market opportunities" },
      { title: "Merchandising", desc: "We perform comprehensive management of all rights including portrait and copyrights while protecting them from unauthorized use to promote market activation" },
    ],
    businessOverview_ja: [
      { title: "CASTING", desc: "アスリートの感性や視点、経験や実績を基に最適なキャスティングをサポートする業務を行います" },
      { title: "MARKETING", desc: "アスリートの社会的価値を追求し、新しいビジネスの創造に取り組むマーケティング業務を行います" },
      { title: "MERCHANDISING", desc: "アスリートに帰属するあらゆる権利の管理・運営を行い、健全な市場活性化を推進する実務を行います" },
    ],
    info: { 
      companyName: "RICEBALL PLANNING Co., Ltd.",
      companyName_ja: "株式会社RICEBALL PLANNING",
      representative: "Representative Director CEO: SATOSHI NISHIKAWA\nDirector COO: YUJI MIYAMOTO",
      // 西川さん：役職から離す（スペース増）
      // 宮本さん：役職へ近づける（スペース減）
      representative_ja: "代表取締役CEO　 西川 聡\n取締役COO　　宮本 雄司",
      established: "2019",
      capital: "1,000,000 JPY",
      capital_ja: "100万円",
      business: "Management, casting, marketing, and merchandise",
      business_ja: "アスリートマネジメント、キャスティング、マーケティング、マーチャンダイズ",
      mainBank: "Sumitomo Mitsui Banking Corporation, Umeda Branch",
      mainBank_ja: "三井住友銀行 梅田支店",
      location: "2-11-5 Azabu-juban, Minato-ku, Tokyo",
      location_ja: "〒106-0045 東京都港区麻布十番2-11-5"
    },
    mapCode: `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3241.935703222362!2d139.73173587687717!3d35.653955731469956!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188ba0345c85a5%3A0xe42a03b49b616c1!2z44CSMTA2LTAwNDUg5p2x5Lqs6YO95riv5Yy66bq75biD5Y2B55Wq77yS5LiB55uu77yR77yR4oiS77yV!5e0!3m2!1sja!2sjp!4v1774017581096!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`,
    accentColor: "#E85D3A",
    bgColor: "#FFF8F5",
  },
];

export const associateCompanies: Company[] = [
  {
    slug: "meet",
    name: "MEET",
    tagline: "Community & Connection Platform",
    logo: "/logo/meet.png",
    website: "https://www.meet-meet.com/",
    description: "MEET is a community-driven platform using NFC technology",
    description_ja: "MEETは、NFC技術を活用したコミュニティ主導のプラットフォームです",
    businessOverview: [
      { title: "NFC Solutions", desc: "NFC chip utilization business" },
      { title: "Marketing Strategy", desc: "Promotion and consulting" },
      { title: "System Dev", desc: "Platform and software development" },
    ],
    businessOverview_ja: [
      { title: "NFCソリューション", desc: "NFCチップ活用及びその周辺領域の事業" },
      { title: "マーケティング戦略", desc: "販売促進、広告代理、コンサルティング" },
      { title: "システム開発", desc: "プラットフォーム、ソフトウェアの企画・制作・保守" },
    ],
    info: { 
      companyName: "MEET Co., Ltd.",
      companyName_ja: "MEET株式会社",
      representative: "-",
      representative_ja: "-",
      established: "2022",
      business: "NFC technology, advertising, marketing, and software development",
      business_ja: "NFCチップ活用事業、広告代理、マーケティング、ソフト開発等",
      location: "Basement Factory Bldg., 1-50-13 Tsurumaki, Setagaya-ku, Tokyo",
      location_ja: "東京都世田谷区弦巻一丁目50番13号 ベースメントファクトリービル"
    },
    mapCode: `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d205.48946827955024!2d139.6477276502509!3d35.638398316965855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f59eda72d9b9%3A0x5bb173188725562f!2sBasement%20Factory%20Group!5e0!3m2!1sja!2sjp!4v1774017647463!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`,
    accentColor: "#E85D3A",
    bgColor: "#FFF8F5",
  },
  {
    slug: "bfp",
    name: "BASEMENT FACTORY PRODUCTIONS",
    tagline: "Web & Creative Production",
    logo: "/logo/bfp.png",
    website: "https://bfp.co.jp/",
    description: "BASEMENT FACTORY PRODUCTIONS is a full-service creative production company",
    description_ja: "BASEMENT FACTORY PRODUCTIONSは、クリエイティブ制作全般を行うプロダクションです",
    businessOverview: [
      { title: "Web Production", desc: "Strategic planning and system development" },
      { title: "Design & Creative", desc: "Graphic and visual design production" },
      { title: "Music & Video", desc: "Music production and artist management" },
    ],
    businessOverview_ja: [
      { title: "Web制作", desc: "サイトの企画・制作・運営およびシステム構築" },
      { title: "デザイン制作", desc: "グラフィックをメインとした各種デザインの企画・制作" },
      { title: "音楽・映像制作", desc: "音楽制作、映像制作、アーティストマネジメント" },
    ],
    info: { 
      companyName: "BASEMENT FACTORY PRODUCTIONS",
      companyName_ja: "株式会社ベースメントファクトリープロダクション",
      representative: "-",
      representative_ja: "-",
      established: "2003",
      business: "Web production, design, system architecture, music and video production",
      business_ja: "Web制作、デザイン、システム構築、音楽・映像制作、飲食事業",
      location: "Basement Factory Bldg., 1-50-13 Tsurumaki, Setagaya-ku, Tokyo",
      location_ja: "〒154-0016 東京都世田谷区弦巻1-50-13 ベースメントファクトリービル"
    },
    mapCode: `<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d205.48946827955024!2d139.6477276502509!3d35.638398316965855!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018f59eda72d9b9%3A0x5bb173188725562f!2sBasement%20Factory%20Group!5e0!3m2!1sja!2sjp!4v1774017647463!5m2!1sja!2sjp" width="600" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>`,
    accentColor: "#333333",
    bgColor: "#F5F5F5",
  },
];

export const visibleAssociateCompanies = associateCompanies.filter(
  (company) => company.slug !== "bfp"
);
